/**
 * @author Leonel Martinez
 * @fileoverview Set all the routes paths to avoid hardcoding directly in the files and components.
 * @enum ROUTES
 */
export const ROUTES = {
  ROOT: "/:provider",
  VEHICLE: "/:provider/vehicle",
  NEW_VEHICLE: "/:provider/new/vehicle",
  RECENT_VEHICLES: "/:provider/recent/vehicles",
  NOT_FOUND: "/:provider/404",
  GENERIC: "*",
  CATALOG: "/:provider/catalog/",
  PARTS_LOOKUP: "/:provider/parts-lookup/",
  PARTS_RESULT: "/:provider/parts-result/",
  INTERCHANGE_RESULTS: "/:provider/interchange-results/",
  TERMS_OF_USE: "/:provider/terms-use",
  HELP: "/:provider/help",
  VERSION: "/:provider/version",
  PART_LIST: "/:provider/part-list"
}